import moment from 'moment';
import type { TMealPlanFormData, TMealPlanItem, TMealPlanRequest } from 'interfaces/mealPlan';

const MEAL_PLAN_ITEM_INPUT_FIELDS = [
  'mealPlanItemName',
  'description',
  'calories',
  'carbohydrate',
  'protein',
  'fat',
  'natrium',
  'sugar'
] as const;

// 식단 구성이 없는 식단은 폼이 빈 행을 기본으로 넣는다 — 식단구성 미사용이면 메뉴명 검증이 없어 이 행이 그대로 전송되므로 뺀다
export const isEmptyNewMealPlanItem = (item: TMealPlanItem): boolean =>
  !item.mealPlanItemIdx &&
  MEAL_PLAN_ITEM_INPUT_FIELDS.every((field) => {
    const value = item[field];
    return value === null || value === undefined || String(value).trim() === '';
  });

export const buildMealPlanRequest = (
  values: TMealPlanFormData,
  { uploadedImageUrl, currentImageUrl }: { uploadedImageUrl?: string | null; currentImageUrl?: string | null }
): TMealPlanRequest => {
  const { mealPlanImage, serveDate, ...other } = values;
  // 이미지를 바꾸지 않은 수정은 기존 URL 그대로 — 서버가 저장된 URL과 같으면 presigned 검증을 생략한다 (v1 업로드 URL 포함)
  const mealPlanImageUrl = uploadedImageUrl ?? (other.isDeleteImage ? null : currentImageUrl ?? null);
  return { ...other, serveDate: moment(serveDate).format('YYYY-MM-DD'), mealPlanImageUrl };
};
